module.exports = __webpack_public_path__ + "img/icon-shouye.8b027b49.svg";